import React, { useEffect, useState } from "react";
import StepProgressBar from "react-step-progress";
import "react-step-progress/dist/index.css";
import classnames from "classnames";
import logo from "../../../../assets/images/logo/logo.png";
import { capitalizeFirstLetter } from "../../../../utils/utils";
import {
  DASHBOARD_USER_ROLES,
  onboardingStepsEnum,
} from "../../../../constants";
import { Card, Col } from "reactstrap";

const OnboardingSideBar = ({ activeVerticalTab, currentUser }) => {
  const [startingStep, setStartingStep] = useState(0);

  // Funciones de validación para cada paso
  function step2Validator() {
    return true;
  }

  function step3Validator() {
    return true;
  }

  function onFormSubmit() {
    console.log("Formulario enviado");
  }

  const steps = [
    {
      tab:
        currentUser.role === DASHBOARD_USER_ROLES.BROKER
          ? onboardingStepsEnum.StepOneBroker
          : onboardingStepsEnum.StepOne,
      label: (
        <div className="step-label-container">
          <div className="step-number-label">Step 1</div>
          <h6 className="step-label-label">{`${
            currentUser.role === DASHBOARD_USER_ROLES.EMPLOYER
              ? "Company"
              : currentUser.role === DASHBOARD_USER_ROLES.GA
              ? "GA"
              : `${capitalizeFirstLetter(currentUser.role)}`
          } Details`}</h6>
        </div>
      ),
      content: null,
    },
    {
      tab: onboardingStepsEnum.PaymentStep,
      label: (
        <div className="step-label-container">
          <div className="step-number-label">Step 2</div>
          <h6 className="step-label-label">Payment Information</h6>
        </div>
      ),
      content: null,
      validator: step2Validator,
    },
    ...(currentUser.role === DASHBOARD_USER_ROLES.EMPLOYER
      ? [
          {
            tab: onboardingStepsEnum.EmployerEmployeesStep,
            label: (
              <div className="step-label-container">
                <div className="step-number-label">Step 3</div>
                <h6 className="step-label-label ">Employee Details</h6>
              </div>
            ),
            content: null,
            validator: step3Validator,
          },
        ]
      : []),
    ...(currentUser.role !== DASHBOARD_USER_ROLES.NATIONAL
      ? [
          {
            tab: onboardingStepsEnum.AgreementStep,
            label: (
              <div className="step-label-container">
                <div className="step-number-label">
                  {currentUser.role === DASHBOARD_USER_ROLES.EMPLOYER
                    ? "Step 4"
                    : "Step 3"}
                </div>
                <h6 className="step-label-label">Agreements</h6>
              </div>
            ),
            content: null,
          },
        ]
      : []),
  ];

  const stepComponents = steps.map((step) => ({
    label: step.label,
    name: step.label,
    content: step.content,
    validator: step.validator,
  }));

  useEffect(() => {
    const newStartingStep = steps.findIndex(
      (step) => step.tab === activeVerticalTab
    );
    setStartingStep(newStartingStep >= 0 ? newStartingStep : 0);
  }, [activeVerticalTab, steps]);

  return (
    <Card
      className="align-items-start justify-content-start d-flex flex-column w-100 p-0 pt-0 pb-4"
      style={{ backgroundColor: "#243142", width: "100%" }}
    >
      <StepProgressBar
        key={startingStep}
        contentClass="step-progress-content"
        className="step-progress-bar"
        startingStep={startingStep}
        onSubmit={onFormSubmit}
        steps={stepComponents}
        hideNavigation
      />
    </Card>
  );
};

export default OnboardingSideBar;
